export class BackupZeroEtlSingleResourceRoutingPolicy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "identityColumns",
            "baseName": "identityColumns",
            "type": "Array<BackupZeroEtlIdentityColumnSpec>",
            "format": ""
        },
        {
            "name": "tableMappingMode",
            "baseName": "tableMappingMode",
            "type": "BackupZeroEtlSingleResourceTableMappingMode",
            "format": ""
        },
        {
            "name": "mergeDatabasesParams",
            "baseName": "mergeDatabasesParams",
            "type": "BackupZeroEtlSingleResourceTableMappingMergeDatabasesParams",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlSingleResourceRoutingPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
